import { render, staticRenderFns } from "./AwardCreate.vue?vue&type=template&id=6a3a35de"
import script from "./AwardCreate.vue?vue&type=script&lang=ts"
export * from "./AwardCreate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports